
const homepage = () => import('@/page/mail/homepage')

const homepageRouter = [{
    path: 'homepage',
    name: 'homepage',
    component: homepage
}, {
    path: '*',
    redirect: {
        name: 'homepage'
    }
}]

export default homepageRouter


// WEBPACK FOOTER //
// ./src/router/homepage.js